import {IEntity} from "./IEntity";
import {IGuidItem} from "./IGuidItem";
import {IOptionSetItem} from "./IOptionSetItem";

export interface IAcrBasicInformation extends IEntity {
    RequestId?: string;
    AircraftType?: IGuidItem;
    AircraftModel?: IGuidItem;
    AircraftSeries?: IGuidItem;
    AircraftManufacturer?: IOptionSetItem;
    MsnNumber?: string;
    ProposedRegistrationMark?: string;
    ContractType?: string;
    Regions?: string;
    Status?: string;
}


export const AcrBasicInformation: IAcrBasicInformation = {
    MsnNumber: '',
    ProposedRegistrationMark: '',
    ContractType: '',
    Regions: ''
}